module.exports = __webpack_public_path__ + "b7f4cf9144a2b973ff432a78fa705168.png";